"use client"
import React from "react";
import { Heading } from "@/components/ui/typography";

const data = [
  {
    feature: "Approval Difficulty",
    traditional: "High for foreign founders",
    fintech: "Moderate",
  },
  {
    feature: "Branch Visit Required",
    traditional: "Usually yes",
    fintech: "No — fully remote",
  },
  {
    feature: "Currencies Supported",
    traditional: "Strong",
    fintech: "Strong",
  },
  {
    feature: "Processing Time",
    traditional: "Weeks to months",
    fintech: "Days to weeks",
  },
  {
    feature: "Online Experience",
    traditional: "Improving but slower",
    fintech: "Built for digital founders",
  },
  {
    feature: "Best For",
    traditional: "Companies with HK presence",
    fintech: "Remote eCommerce, SaaS, agencies",
  },
];

export default function Compare({ heading = "Traditional Bank vs Fintech HK Company Banking Options" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[30px] md:py-[60px]">
      <div className="max-w-[1200px] mx-auto px-4">

        {/* HEADING */}
        <Heading as="h2" variant="sectionCentered" className="max-w-[600px] mx-auto">
          {heading}
        </Heading>

        {/* TABLE */}
        <div className="mt-5 md:mt-12 rounded-2xl overflow-hidden border border-white/10">
<div className="overflow-x-auto">
    <div className="min-w-[700px]">
 {/* HEADER */}
          <div className="bg-[#1E1E1E] text-white grid grid-cols-3 sm:grid-cols-3 gap-4 px-6 py-5 text-sm sm:text-lg font-medium font-cambo">
            <div>Feature</div>
            <div>Traditional Banks (HSBC, Standard Chartered)</div>
            <div>Fintech Multi-Currency (Airwallex, Statrys, Wise)</div>
          </div>

          {/* ROWS */}
          {data.map((row, index) => (
            <div
              key={index}
              className={`grid grid-cols-3 sm:grid-cols-3 gap-4 px-6 py-5 text-sm sm:text-base ${
                index % 2 === 1 ? "bg-[#0f1218]" : "bg-black"
              }`}
            >
              <div className="font-medium text-white">
                {row.feature}
              </div>
              <div className="text-white">
                {row.traditional}
              </div>
              <div className="text-white">
                {row.fintech}
              </div>
            </div>
          ))}
    </div>
</div>
         
        </div>

      </div>
    </section>
  );
}